export default {
  加载中: 'Loading',
  发布时间_filter: 'Posting time',
  国外_filter: 'World',
  国内_filter: 'China',
  展开筛选: 'Expand',
  收起筛选: 'Collapse',
  清除筛选: 'Clear',
  已选条件: 'Selected',
  行业分类: 'Industry',
  展览地区: 'Region',
  举办日期: 'Date',
  会议地区: 'Region',
  角色类型: 'Role',
  头条分类: 'Category',
}
